export const GET_DRUG_RULES_SETTINGS = 'drugRulesSetting/GET_DRUG_RULES_SETTINGS'
export const GET_DRUG_RULES_SETTINGS_SUCCESS = 'drugRulesSetting/GET_DRUG_RULES_SETTINGS_SUCCESS'
export const GET_DRUG_RULES_SETTINGS_ERROR = 'drugRulesSetting/GET_DRUG_RULES_SETTINGS_ERROR'
export const SET_DRUG_RULES_SETTINGS_BY_USER_ID = 'drugRulesSetting/SET_DRUG_RULES_SETTINGS_BY_USER_ID'
